import { ReactElement } from 'react'

import { useAppSelector } from '@/stores/hooks.ts'
import { ToCPaymentsTable } from '@/pages/sbp-payments/sbp-payments-table/to-c-payments-table.tsx'
import { ToBPaymentsTable } from '@/pages/sbp-payments/sbp-payments-table/to-b-payments-table.tsx'

export const SbpPaymentsTable = (): ReactElement => {
  const sbpType = useAppSelector((state) => state.sbpPayments.sbpType)

  return sbpType === 'B2C' ? <ToCPaymentsTable /> : <ToBPaymentsTable />
}
